import { Component } from 'react';
import { FieldArray as FormikFieldArray } from 'formik';

class FieldArray extends Component {
    render() {
        const { validateOnChange = false, ...rest } = this.props;

        return <FormikFieldArray validateOnChange={validateOnChange} {...rest} />;
    }
}

export default FieldArray;
